import { Inject, Injectable, Optional } from '@angular/core';

import * as io from 'socket.io-client';

import { RUN_MODE_TOKEN, RunMode } from 'src/environments/runtime';

import { CLOUD_HOST, GANDALF_HOST, GATEWAY_SERVICES } from '../../utils/constants';
import { EndpointService } from '../endpoint/endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket_: io.Socket;

  constructor(
    private endpointService: EndpointService,
    @Optional() @Inject(RUN_MODE_TOKEN) private runMode: RunMode | null,
    @Inject('Window') private window: Window
  ) {
    this.initializeSocket();
  }

  private initializeSocket(): void {
    if (this.runMode === 'cloud' && this.endpointService.nodeId) {
      // In cloud mode, both frodo-api (FrodoService) and gandalf
      // (SocketService) are exposed through the shared cloud gateway.
      // This socket carries the gandalf events (door-closed, presence,
      // space-action, etc.) that power the physical sensor UI flows.
      this.socket_ = io.connect(CLOUD_HOST, {
        path: `/gateway/${GATEWAY_SERVICES.GANDALF}/socket.io`,
        query: { deviceId: this.endpointService.nodeId },
        transports: ['websocket'],
        reconnectionDelay: 2000,
        reconnectionDelayMax: 30000,
        randomizationFactor: 0.5,
      });
    } else if (!CLOUD_HOST.includes(this.window.location.hostname)) {
      this.socket_ = io.connect(GANDALF_HOST, {
        transports: ['websocket'],
        reconnectionDelay: 2000,
        reconnectionDelayMax: 30000,
        randomizationFactor: 0.5,
      });
    }
  }

  get socket() {
    return this.socket_;
  }

  setSocketHost(host: string) {
    if (!this.socket_)
      this.socket_ = io.connect(host, {
        transports: ['websocket'],
        reconnectionDelay: 2000,
        reconnectionDelayMax: 30000,
        randomizationFactor: 0.5,
      });
  }

  listen(eventName: string, callbackFn: (...args: any[]) => unknown) {
    this.socket_.off(eventName);
    this.socket_.on(eventName, callbackFn);
  }
}
